import moment from 'moment';
import { joinedValuesSeparator, dateFormat } from '@/ts/DefaultTableConfigs';

export default class VacantUnitData {
    public id: number;
    public name: string;
    public project: string;
    public address: string;
    public availableFrom: string;
    public groups: string;
    public activePresentationCount: number;
    public activePresentations: any;
    public type: string;

    constructor(
        id: number,
        name: string,
        project: string,
        address: string,
        releaseDate: string,
        propertyAvailable: string,
        groups: string[],
        activePresentations: any,
        type: string,
    ) {
        this.id      = id;
        this.name    = name;
        this.project = project;
        this.address = address;
        this.groups  = groups.join(joinedValuesSeparator);
        this.type    = type;
        this.activePresentationCount = activePresentations.length;
        this.activePresentations = activePresentations;
        this.availableFrom = 'Available now';

        if (releaseDate !== null && new Date(releaseDate) > new Date()) {
            this.availableFrom = moment(releaseDate).format(dateFormat);
        }

        if (propertyAvailable !== null && new Date(propertyAvailable) > new Date()) {
            this.availableFrom = moment(propertyAvailable).format(dateFormat);
        }
    }
}
